import { useState } from 'react';
import { Delete } from '@mui/icons-material';
import { DELETE_ADFS, GET_ADFS } from './ADFSConfig.graphql';
import ConfirmDialog from '../../components/ConfirmDialog';
import { GET_LICENSE } from '../../licenses/details/LicenseInfo.graphql';
import { useMutation } from '@apollo/client/react';
import { Button, IconButton } from '@mui/material';
import { ALL_IDENTITY_PROVIDERS } from '../../sso/Sso.graphql';
interface Prop {
  provider?: string | null;
  licenseId: number;
  onDeleted?: () => void;
  labelled?: boolean;
}
export default function DeleteAdfs(props: Prop) {
  const { provider, licenseId, onDeleted, labelled } = props;

  const handleDelete = () => {
    setOpen(true);
  };
  const [open, setOpen] = useState(false);
  const onClose = () => {
    setOpen(false);
  };
  return (
    <>
      {labelled ? (
        <Button variant="outlined" color="error" startIcon={<Delete />} onClick={() => handleDelete()}>
          Fjern firmapålogging
        </Button>
      ) : (
        <IconButton sx={{ cursor: 'pointer' }} onClick={() => handleDelete()} title="Fjern firmapålogging" size="large">
          <Delete />
        </IconButton>
      )}
      <DeleteDialog open={open} onClose={onClose} name={provider} licenseId={licenseId} />
    </>
  );
  function DeleteDialog({ open, onClose, name, licenseId }) {
    const [remove] = useMutation<any>(DELETE_ADFS, {
      variables: {
        input: {
          adfsScheme: name,
          bksID: licenseId,
        },
      },
      refetchQueries: [
        {
          query: GET_LICENSE,
          variables: { id: licenseId },
        },
        {
          query: GET_ADFS,
        },
        { query: ALL_IDENTITY_PROVIDERS },
      ],
    });
    const onSave = async () => {
      await remove();
      onClose(false);
      onDeleted?.();
    };
    let msg = `Vil du fjerne firmapåloggingen ${name} fra lisensen? Brukerne kan da ikke lenger logge inn via kundens Entra ID.`;
    return (
      <ConfirmDialog
        title="Fjern firmapålogging?"
        message={msg}
        open={open}
        confirm={onSave}
        deny={onClose}
        confirmText="Fjern"
        confirmColor="error"
        denyVariant="text"
        DialogProps={{ fullWidth: true, maxWidth: 'xs' }}
      />
    );
  }
}
